module.exports = __webpack_public_path__ + "images/emoji/left_luggage.81928248773996ae259f.png";